import {Alert} from 'antd';

const AlertWarning = (props) => (
  <Alert
    type="warning"
    {...props}
  />
);

export default AlertWarning;
